import { zodResolver } from "@hookform/resolvers/zod";
import { HeaderForm } from "@/components/header-form";
import { Button } from "@/components/ui/button";
import { Form } from "@/components/ui/form";
import { SimpleAccordion } from "@/components/ui/simple-accordion";
import { useForm } from "react-hook-form";
import { ProjectDetailsFormData, projectDetailsFormSchema } from "./schema";
import { ProjectDetailsForm } from "./project-details-form";
import { useUpdateProject, useGetProjectById } from "@/services/queries/useProject";
import { ProjectDetails as ProjectDetailsType } from "@/types/project";
import { useEffect } from "react";

interface ProjectDetailsProps {
  onContinue?: () => void;
  onBack?: () => void;
  projectId?: number;
}

export function ProjectDetails({ onContinue, projectId }: ProjectDetailsProps) {
  const form = useForm<ProjectDetailsFormData>({
    resolver: zodResolver(projectDetailsFormSchema),
    defaultValues: {
      sinopse: "",
      negociacao: "",
      step: "",
      protocol: "",
      janelas_exibicao: "",
      uf: "",
      country: "",
      approvedValue: "",
      capturedValue: "",
      language: "",
      time: "",
    },
  });

  const { data: project } = useGetProjectById(projectId || 0);

  useEffect(() => {
    if (project) {
      form.reset({
        sinopse: project.description || "",
        // negociacao: project.negociacao || "", // Not in IProject yet?
        step: String(project.id_movie_status || ""),
        protocol: project.protocol_number || "",
        // janelas_exibicao: project.janelas_exibicao || "", // Not in IProject yet?
        uf: project.state?.name || "",
        country: project.country?.name || "Brasil",
        approvedValue: String(project.budgets?.[0]?.amount || ""),
        capturedValue: String(project.budgets?.[0]?.total_amount || ""),
        language: project.movie_original_language || "",
        time: String(project.movie_time || ""),

        // Populate other fields if they exist in IProject but were missing from mapped object
        negociacao: "Direta", // Placeholder if missing
        janelas_exibicao: "Cinema", // Placeholder if missing
      });
    }
  }, [project, form]);

  const { mutateAsync: updateProject } = useUpdateProject()

  const onFormSubmit = async (data: ProjectDetailsFormData) => {
    try {
      const projectDetailsData = ProjectDetailsType.mapToProjectDetails(projectId ?? 0, data)
      await updateProject(projectDetailsData)

      onContinue?.()
    } catch (error) {
      console.error("Erro ao salvar detalhes do projeto:", error)
    }
  }

  const accordionItems = [
    {
      name: "DETALHES DO PROJETO",
      component: <ProjectDetailsForm form={form} />,
    },
  ]

  return (
    <Form {...form}>
      <form onSubmit={form.handleSubmit(onFormSubmit)} className="space-y-8">
        <SimpleAccordion
          className="bg-darkblue rounded-lg p-8"
          itemClassName="border-none"
          items={accordionItems.map((item) => ({
            id: item.name,
            title: <HeaderForm title={item.name} />,
            content: item.component
          }))}
        />

        {/* Navigation Buttons */}
        <div className="flex justify-end gap-10">
          <Button
            variant="outline"
            type="submit"
            size="lg"
            className="w-[251px] h-[59px] border-[#7846ff] text-[#7846ff] hover:bg-[#7846ff] hover:text-white font-bold text-sm"
          >
            Voltar
          </Button>

          <Button
            type="submit"
            size="lg"
            className="w-[251px] h-[59px] bg-[#13d480] hover:bg-[#13d480]/90 text-white font-bold text-base"
          >
            Salvar & Continuar
          </Button>
        </div>
      </form>
    </Form>
  )
}